<template>
	<div ref="anchorElementRef" :style="style" @mouseenter="show" @mouseleave="hide">
		<slot />
	</div>

	<MbscPopup
		v-if="!hideContent && anchorElementRef && isTooltipVisible"
		css-class="tooltipPopup"
		display="anchored"
		:anchor="anchorElementRef"
		:touch-ui="false"
		:show-overlay="false"
		:content-padding="false"
		:close-on-overlay-click="false"
		:scroll-lock="false"
		theme="no-theme"
		:animation="false"
		is-open
	>
		<slot name="content">{{ content }}</slot>
	</MbscPopup>
</template>

<script setup lang="ts">
import { MbscPopup } from '@mobiscroll/vue'
import { ref, type StyleValue } from 'vue'

withDefaults(
	defineProps<{
		hideContent?: boolean
		delay?: number
		maxWidth?: number
		content?: string
		style?: StyleValue
	}>(),
	{
		delay: 200,
		maxWidth: 350,
		content: undefined,
		style: undefined
	}
)

const anchorElementRef = ref()

const isTooltipVisible = ref(false)

let timeoutId: number | undefined

function show() {
	timeoutId = window.setTimeout(() => {
		isTooltipVisible.value = true
	}, 200)
}

function hide() {
	window.clearTimeout(timeoutId)
	isTooltipVisible.value = false
}
</script>

<style lang="scss">
@import '@bluebrick/saas-ui/saas-ui.css';

.tooltipPopup .mbsc-popup-body {
	@apply font-body-s rounded bg-level-00;

	border: var(--border);
	border-color: theme('colors.level.02');
	box-shadow: theme('boxShadow.1');
	color: theme('textColor.normal');
	padding: 0;
}

.tooltipPopup .mbsc-popup-arrow-wrapper-top,
.tooltipPopup .mbsc-popup-arrow-wrapper-bottom {
	height: 0.75rem;
}

.tooltipPopup .mbsc-popup-arrow {
	@apply bg-level-02;
}

.tooltipPopup .mbsc-popup-arrow-bottom {
	top: 0.75rem;
}

.tooltipPopup .mbsc-popup-arrow-top {
	bottom: 0.75em;
}

.tooltipPopup .mbsc-popup-content {
	padding: theme('spacing.05');
}
</style>
